import { createElement } from "../../utils/domHelpers";
import { loadCompetitionCatalogue } from "../../services/competitionCatalogue";

export function renderCatalogueUnavailable(
	container: HTMLElement,
	onRetry: () => Promise<void>,
): void {
	const section = createElement("div", {
		className: "alert alert-warning my-4",
		attributes: { role: "alert" },
	}, container);
	createElement("p", {
		textContent: "Championship information is unavailable. Check your connection and try again.",
	}, section);
	const button = createElement("button", {
		className: "btn btn-outline-dark",
		textContent: "Try again",
		attributes: { type: "button" },
	}, section);
	button.onclick = async () => {
		button.disabled = true;
		try {
			await loadCompetitionCatalogue(true);
			await onRetry();
			section.remove();
		} catch (error) {
			console.error("Championship information retry failed:", error);
			button.disabled = false;
		}
	};
}
